<template>
    <div style="text-align: center">
        <div
            class="search_form"
            :class="{
                'ai-border': searchFocused
            }"
        >
            <form ref="searchForm" @submit.prevent="onSubmit">
                <div class="form">
                    <input
                        id="search"
                        v-model="search"
                        name="search"
                        class="form_control"
                        type="text"
                        :placeholder="
                            iframeLoading
                                ? $t('homepage.aiSearchLoadingPlaceholder')
                                : aiSearchPlaceholder
                        "
                        @focus="searchFocused = true"
                        @blur="searchFocused = false"
                    />
                    <button
                        class="btn btn_gray btn_reset btn_search btn_search_ai"
                        :class="{
                            btn_search_ai_loading: iframeLoading
                        }"
                        type="submit"
                    >
                        <picture v-full-image-path:assets="'ai_search.svg'" />
                        <div class="label">
                            {{ $t('homepage.searchButton') }}
                        </div>
                    </button>
                </div>
            </form>
        </div>

        <p style="margin-top: 9px; font-size: 11px; color: #596172">
            <i18n path="homepage.searchWarning">
                <nuxt-link
                    :to="localePath('/privacy-policy')"
                    class="ai-warning-link"
                >
                    {{ $t('homepage.searchWarningLinkText') }}
                </nuxt-link>
            </i18n>
        </p>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        searchOnInput: {
            type: Boolean,
            required: false,
            default: false
        },

        limit: {
            type: Object,
            default: () => null
        }
    },

    data() {
        return {
            search: '',
            searchFocused: false,
            results: {},
            showSearchResults: false,
            iframeLoading: false
        };
    },

    computed: {
        isMobile() {
            return !this.$device.isDesktopOrTablet;
        },

        aiSearchPlaceholder() {
            return this.isMobile
                ? this.$t('homepage.aiSearchPlaceholder.mobile')
                : this.$t('homepage.aiSearchPlaceholder.desktop');
        }
    },

    methods: {
        ...mapActions({
            fetchSearchedItems: 'search/index',
            sendMessage: 'aiChatbot/sendMessage'
        }),

        onSubmit() {
            if (!this.search) {
                return;
            }

            this.sendMessage(this.search);

            this.search = '';
        }
    }
};
</script>

<style scoped>
.ai-warning-link {
    color: #596172;
    text-decoration: underline;
    margin-right: 16px;
}
</style>
